import React from 'react';

const companies = [
  "Training Co.", "YouTube Creator", "L&D Team", "Agency", 
  "Course Platform", "Media Company", "Consulting Firm", "Corporate University"
];

const LogoStrip = () => {
  return (
    <section className="py-16 md:py-20 border-y border-white/10 bg-brand-card/40 backdrop-blur-xl relative overflow-hidden">
      {/* Decorative separators */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-brand-mint/50 to-transparent"></div>
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-brand-mint/50 to-transparent"></div>
      
      {/* Enhanced gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-brand-neon/10 via-transparent to-brand-electric/10 pointer-events-none"></div>
      
      <div className="max-w-7xl mx-auto px-4 text-center mb-8 md:mb-10 relative z-10">
        <p className="text-brand-electric text-xs md:text-sm uppercase tracking-widest font-bold drop-shadow-[0_0_10px_rgba(0,229,255,0.5)]">
          Trusted by industry leaders
        </p>
      </div>

      <div className="relative overflow-hidden flex">
        {/* Stronger gradient masks */}
        <div className="absolute left-0 top-0 bottom-0 w-20 md:w-40 z-10 bg-gradient-to-r from-brand-darker via-brand-darker/90 to-transparent"></div>
        <div className="absolute right-0 top-0 bottom-0 w-20 md:w-40 z-10 bg-gradient-to-l from-brand-darker via-brand-darker/90 to-transparent"></div>

        <div className="flex whitespace-nowrap animate-marquee hover:[animation-play-state:paused]">
          {[...companies, ...companies].map((company, index) => (
            <div
              key={index}
              className="mx-6 md:mx-12 text-lg md:text-2xl font-heading font-bold text-white/60 hover:text-brand-electric transition-all hover:scale-110 cursor-default drop-shadow-[0_2px_10px_rgba(0,0,0,0.5)] hover:drop-shadow-[0_0_15px_rgba(0,229,255,0.5)]"
            >
              {company}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LogoStrip;